import { render, staticRenderFns } from "./base.vue?vue&type=template&id=283bab65&scoped=true&"
import script from "./base.vue?vue&type=script&lang=ts&"
export * from "./base.vue?vue&type=script&lang=ts&"
import style0 from "./base.vue?vue&type=style&index=0&id=283bab65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bab65",
  null
  
)

export default component.exports